var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AppBar, AppBarActions, AppBarContent, styled, Text } from '@a0/quantum-product';
import React from 'react';
import { Sticky } from 'react-sticky';
import updateStickyHeaderVisibility from '../../action/updateStickyHeaderVisibility';
import UserStore from '../../stores/UserStore';
import { ActionArea } from '../Header/ActionArea';
import { useFluxible } from '../hooks/useFluxible';
var HeaderBar = styled(AppBar)(function (_a) {
    var _b;
    var theme = _a.theme, isSticky = _a.isSticky;
    return (__assign(__assign({ visibility: 'hidden', transform: 'translateY(-100%)', transition: 'visibility 0s linear 0.2s, transform 0.2s linear', padding: theme.spacing(0, 3), backgroundColor: theme.palette.common.white }, (isSticky && {
        visibility: 'visible',
        transform: 'translateY(0%)',
        transitionDelay: '0s',
    })), (_b = {}, _b[theme.breakpoints.down('sm')] = {
        padding: 0,
    }, _b)));
});
var HeaderContent = styled(AppBarContent)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down('sm')] = {
            maxWidth: '100%',
            padding: theme.spacing(0, theme.layout.mobileMarginX),
        },
        _b);
});
var Header = React.forwardRef(function (_a, ref) {
    var title = _a.title, isSticky = _a.isSticky;
    var context = useFluxible();
    var userStore = context.getStore(UserStore);
    var user = userStore.getUser();
    var isAuthenticated = userStore.isAuthenticated();
    React.useEffect(function () {
        context.executeAction(updateStickyHeaderVisibility, { isSticky: isSticky });
    }, [isSticky]);
    return (React.createElement(HeaderBar, { ref: ref, isSticky: isSticky },
        React.createElement(HeaderContent, null,
            React.createElement(AppBarActions, null,
                React.createElement(Text, { variant: "h5" }, title)),
            React.createElement(AppBarActions, { flex: 1, justifyContent: "flex-end" },
                React.createElement(ActionArea, { placement: "header", isAuthenticated: isAuthenticated, user: user })))));
});
export var StickyHeader = function (_a) {
    var title = _a.title;
    return React.createElement(Sticky, { disableCompensation: true }, function (_a) {
        var isSticky = _a.isSticky;
        return React.createElement(Header, { title: title, isSticky: isSticky });
    });
};
